import { API } from "../store"
import handleCatch from "../lib/catch"

export const setSuperAdminBillingInformation = billingInformation => {
  return {
    type: "SUPER_ADMIN::SET_BILLING_INFORMATION",
    data: billingInformation,
  }
}

const updateExpenseType = updatedData => {
  return {
    type: "DEAL_MEMO::UPDATE_EXPENSES_TYPES",
    payload: {
      ...updatedData,
    },
  }
}

export const getSuperBillingTableData = requestData => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.post("/billing/get-billing")
        .send(requestData)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response.body
        })
        .then(response => {
          // using SuperTableContext instead of redux now
          resolve(response)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

// an action that can update any KEY and VALUE in the GENERAL_DATA
export const updateExpenseListType = (expenseID, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/item-types/${expenseID}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            dispatch(updateExpenseType(response.updated_data))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const createExpenseListType = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/shoots/item-types/create`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const inviteUserToStripe = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post("/invite-stripe-by-admin")
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getUserTransferHistory = (userId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/transfer-history/${userId}`)
          .send(data)
          .then(response => {
            return response
          })
          .then(response => {
            return response.body
          })
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const transferPayment = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post("/transfer-payment")
          .send(data)
          .then(response => {
            return response
          })
          .then(response => {
            return response.body
          })
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const markAsPaidCall = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post("/paid-payment")
          .send(data)
          .then(response => {
            return response
          })
          .then(response => {
            return response.body
          })
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(() => call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
